
import "../Css/groovePQR_pdf.css";
import PQR_Footer from "./PQR_Footer";
import TTS_pdf_headerPQRpage2 from "./TTS_pdf_headerPQRpage2";

const PQRTubeToTubesheet_pdf_page2 = (
  { pdf, previewuser, previewapproved },
) => {

  const width = "72.6%";

  // Debug logs for PDF Page 2
  console.log('=== PDF PAGE 2 DATA ===');
  console.log('PDF prop received:', pdf);
  console.log('PDF length:', pdf?.length);
  if (pdf && pdf.length > 0) {
    console.log('PDF[0] in page 2:', pdf[0]);
    if (pdf[1]) {
      console.log('PDF[1] in page 2:', pdf[1]);
      console.log('Visual Examination in PDF[1]:', pdf[1]?.Visual_Examination);
      console.log('Liquid Penetrant in PDF[1]:', pdf[1]?.Liquid_Penetrant_Examination);
      console.log('Macro Examination in PDF[1]:', pdf[1]?.Macro_Examination);
      console.log('Minimum Leak Path in PDF[1]:', pdf[1]?.Minimum_Leak_Path);
    }
  }
  console.log('=== END PDF PAGE 2 DATA ===');

  const styles = {
    container: {
      display: "flex",
    },

    group: {
      display: "flex",
    },

    title3: {
      width: "50%",
    },
  };

  function Max_ProcessesTB1() {
    const rows = [];

    for (let i = 0; i < pdf.length; i++) {
      const macroExamination = pdf[i]?.Macro_Examination || [];
      const table1Data = macroExamination[0]?.Table6 || [];

      for (let j = 0; j < table1Data.length; j++) {
        const item = table1Data[j];

        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_noTop">
              {item.PQR_MEX_Tube_No !== "" ? item.PQR_MEX_Tube_No : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MEX_LocA !== "" ? item.PQR_MEX_LocA : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MEX_LocB !== "" ? item.PQR_MEX_LocB : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MEX_LocC !== "" ? item.PQR_MEX_LocC : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MEX_LocD !== "" ? item.PQR_MEX_LocD : "--"}
            </td>
          </tr>
        );
      }
    }

    return rows;
  }

  function Max_ProcessesTB2() {
    const rows = [];

    for (let i = 0; i < pdf.length; i++) {
      const macroExamination = pdf[i]?.Macro_Examination || [];
      const table2Data = macroExamination[0]?.Table7 || [];

      for (let j = 0; j < table2Data.length; j++) {
        const item = table2Data[j];

        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_noTop">
              {item.PQR_MEX_Tube_No !== "" ? item.PQR_MEX_Tube_No : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MEX_LocA !== "" ? item.PQR_MEX_LocA : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MEX_LocB !== "" ? item.PQR_MEX_LocB : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MEX_LocC !== "" ? item.PQR_MEX_LocC : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MEX_LocD !== "" ? item.PQR_MEX_LocD : "--"}
            </td>
          </tr>
        );
      }
    }

    return rows;
  }

  function Max_ProcessesTB5() {
    const rows = [];

    for (let i = 0; i < pdf.length; i++) {
      const macroExamination = pdf[i]?.Macro_Examination || [];
      const table5Data = macroExamination[0]?.Table10 || [];

      for (let j = 0; j < table5Data.length; j++) {
        const item = table5Data[j];

        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_noTop" style={{ borderRight: "none" }}>
              {item.PQR_MEX_Magnification !== ""
                ? item.PQR_MEX_Magnification
                : "--"}
            </td>
            <td className="PQR_Botmrt" style={{ borderLeft: "none", borderRight: "none" }}>
              {item.PQR_MEX_Acceptance_Criteria !== ""
                ? item.PQR_MEX_Acceptance_Criteria
                : "--"}
            </td>
            <td className="PQR_Botmrt" style={{ borderLeft: "none" }}>
              {item.PQR_MEX_Observation !== ""
                ? item.PQR_MEX_Observation
                : "--"}
            </td>
          </tr>
        );
      }
    }

    return rows;
  }

  // ------------------------------------------------------------------------------------//

  function Min_ProcessesTB1() {
    const rows = [];

    for (let i = 0; i < pdf.length; i++) {
      const minExamination = pdf[i]?.Minimum_Leak_Path || [];
      const table1Data = minExamination[0]?.Table1 || [];

      for (let j = 0; j < table1Data.length; j++) {
        const item = table1Data[j];

        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_noTop">
              {item.PQR_MLP_Tube_No !== "" ? item.PQR_MLP_Tube_No : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_LocA !== "" ? item.PQR_MLP_LocA : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_LocB !== "" ? item.PQR_MLP_LocB : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_LocC !== "" ? item.PQR_MLP_LocC : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_LocD !== "" ? item.PQR_MLP_LocD : "--"}
            </td>
          </tr>
        );
      }
    }

    return rows;
  }

  function Min_ProcessesTB2() {
    const rows = [];

    for (let i = 0; i < pdf.length; i++) {
      const minExamination = pdf[i]?.Minimum_Leak_Path || [];
      const table2Data = minExamination[0]?.Table2 || [];

      for (let j = 0; j < table2Data.length; j++) {
        const item = table2Data[j];

        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_noTop">
              {item.PQR_MLP_Tube_No !== "" ? item.PQR_MLP_Tube_No : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_LocA !== "" ? item.PQR_MLP_LocA : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_LocB !== "" ? item.PQR_MLP_LocB : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_LocC !== "" ? item.PQR_MLP_LocC : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_LocD !== "" ? item.PQR_MLP_LocD : "--"}
            </td>
          </tr>
        );
      }
    }

    return rows;
  }

  function Min_ProcessesTB5() {
    const rows = [];

    for (let i = 0; i < pdf.length; i++) {
      const minExamination = pdf[i]?.Minimum_Leak_Path || [];
      const table5Data = minExamination[0]?.Table5 || [];

      for (let j = 0; j < table5Data.length; j++) {
        const item = table5Data[j];

        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_noTop">
              {item.PQR_MLP_Magnification !== ""
                ? item.PQR_MLP_Magnification
                : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_Acceptance_Criteria !== ""
                ? item.PQR_MLP_Acceptance_Criteria
                : "--"}
            </td>
            <td className="PQR_Botmrt">
              {item.PQR_MLP_Observation !== ""
                ? item.PQR_MLP_Observation
                : "--"}
            </td>
          </tr>
        );
      }
    }

    return rows;
  }

  function VISUAL_EXAMINATION() {
    const rows = [];
    console.log('=== VISUAL EXAMINATION FUNCTION ===');
    console.log('PDF array in VISUAL_EXAMINATION:', pdf);
    
    for (let i = 0; i < pdf.length; i++) {
      console.log(`Processing PDF[${i}]:`, pdf[i]);
      const visualExamination = pdf[i]?.Visual_Examination || [];
      console.log(`Visual_Examination for PDF[${i}]:`, visualExamination);
      
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        console.log(`Visual item [${i}][${j}]:`, item);
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft">
              {renderLPEXCell(item.PQR_VEX_WeldPass)}</td>
            <td className="PQR_right">
              {renderLPEXCell(item.PQR_VEX_Acceptance_Criteria)}</td>
            <td className="PQR_right">
              {renderLPEXCell(item.PQR_VEX_Observation)}</td>
            <td className="PQR_right">
              {renderLPEXCell(item.PQR_VEX_Results)}</td>
          </tr>
        );
      }
    }
    console.log('Visual examination rows generated:', rows.length);
    console.log('=== END VISUAL EXAMINATION ===');
    return rows;
  }

  const renderLPEXCell = (value) => value !== "" ? value : '--';

  function LIQUID_PENETRANT_EXAMINATION() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Liquid_Penetrant_Examination || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft">
              {renderLPEXCell(item.PQR_LPEX_WeldPass)}</td>
            <td className="PQR_right">
              {renderLPEXCell(item.PQR_LPEX_Acceptance_Criteria)}</td>
            <td className="PQR_right">
              {renderLPEXCell(item.PQR_LPEX_Observation)}</td>
            <td className="PQR_right">
              {renderLPEXCell(item.PQR_LPEX_Results)}</td>
          </tr>
        );
      }
    }
    return rows;
  }

  return (
    <div className="PQRMainPDF">
      <br></br> <br></br> <br></br> <br></br>
      <br></br> <br></br> <br></br> <br></br> <br></br>
      <br></br> <br></br> <br></br> <br></br> <br></br>
      <br></br> <br></br> <br></br> <br></br>
      <TTS_pdf_headerPQRpage2 pdf={pdf}></TTS_pdf_headerPQRpage2>
      <div className="group">
        <div className="PQRbasemetal" style={{ width: { width } }}>
          VISUAL EXAMINATION
        </div>
      </div>
      <table className="PQRTablePg2" style={{ width: { width } }}>
        <tr>
          <th className="PQR_border" style={{ width: "25%" }}>Weld Pass</th>
          <th className="PQR_noleft" style={{ width: "25%" }}>Acceptance Criteria</th>
          <th className="PQR_noleft" style={{ width: "25%" }}>Observation  </th>
          <th className="PQR_noleft" style={{ width: "25%" }}>Results</th>

        </tr>

        {VISUAL_EXAMINATION()}
      </table>
      <table className="PQRTablePg2" style={{ width: { width } }}>

        <tr>
          <th className="PQR_border" style={{ width: "80px" }}>Notes</th>
          <td className="PQR_noleft" style={{ textAlign: "left" }}>{pdf[0]?.PQR_VEX_Notes}</td>
        </tr>
        <tr>
          <th className="PQR_noTop" style={{ width: "80px" }}>Report Number</th>
          <td className="PQR_Botmrt" style={{ textAlign: "left" }}>{pdf[0]?.PQR_VEX_ReportNumHorizontal}</td>
        </tr>
      </table>

      {/* -----------------------------LIQUID PENETRANT EXAMINATION----------------------------------- */}

      <div className="group">
        <div className="PQRbasemetal" style={{ width: { width } }}>
          LIQUID PENETRANT EXAMINATION
        </div>
      </div>
      <table className="PQRTablePg2" style={{ width: { width } }}>
        <tr>
          <th className="PQR_border" style={{ width: "25%" }}>Weld Pass</th>
          <th className="PQR_noleft" style={{ width: "25%" }}>Acceptance Criteria</th>
          <th className="PQR_noleft" style={{ width: "25%" }}>Observation  </th>
          <th className="PQR_noleft" style={{ width: "25%" }}>Results</th>

        </tr>
        {LIQUID_PENETRANT_EXAMINATION()}
      </table>
      <table className="PQRTablePg2" style={{ width: { width } }}>

        <tr>
          <th className="PQR_border" style={{ width: "80px" }}>Notes</th>
          <td className="PQR_noleft" style={{ textAlign: "left" }}>{pdf[0]?.PQR_LPEX_Notes}</td>
        </tr>
        <tr>
          <th className="PQR_noTop" style={{ width: "80px" }}>Report Number</th>
          <td className="PQR_Botmrt" style={{ textAlign: "left" }}>{pdf[0]?.PQR_LPEX_ReportNumHorizontal}</td>
        </tr>
      </table>
      {/* -------------------------MACRO EXAMINATION---------------------------------  */}
      {pdf[0]?.macroCheck !== "No" && (<>
        <div
          className="group"
        // style={{  textAlign: "right", width: "50%" }}
        >
          <div className="PQRbasemetal" style={{ width: { width } }}>MACRO EXAMINATION</div>
        </div>
        <div style={styles.container}>
          <div style={{ paddingTop: "20px" }}></div>
          <table
            id="table"
            className="PQRTable6"
            style={{ width: "45%" }}
          >
            <tbody>
              <tr>
                <th className="left-th PQR_border" rowSpan="2" style={{ width: "15%" }}>
                  Tube No
                </th>
                <th className="PQRleft-th-noleft" rowSpan="2" >
                  Loc A
                </th>
                <th className="PQRleft-th-noleft" rowSpan="2" >
                  Loc B
                </th>
                <th className="PQRleft-th-noleft" rowSpan="2" >
                  Loc C
                </th>
                <th className="PQRleft-th-noleft" rowSpan="2" >
                  Loc D
                </th>
              </tr>
              <br></br>
              {Max_ProcessesTB1()}
            </tbody>
          </table>

          <table
            id="table"
            className="PQRTable6"
            style={{
              width: "45%",
              position: "relative",
              right: "1.4cm",
            }}
          >
            <tbody>
              <tr>
                <th className="left-th PQR_border" rowSpan="2" style={{ width: "15%" }}>
                  Tube No
                </th>
                <th className="PQRleft-th-noleft" rowSpan="2" >
                  Loc A
                </th>
                <th className="PQRleft-th-noleft" rowSpan="2" >
                  Loc B
                </th>
                <th className="PQRleft-th-noleft" rowSpan="2" >
                  Loc C
                </th>
                <th className="PQRleft-th-noleft" rowSpan="2" >
                  Loc D
                </th>
              </tr>
              <br></br>
              {Max_ProcessesTB2()}
            </tbody>
          </table>
        </div>

        <br></br>
        <div className="group">
          <table className="PQRTablePg2" style={{ width: { width } }}>
            <tr>
              <th className="PQR_border" style={{ width: "25%", borderRight: "none" }}>Magnification</th>
              <th className="PQR_noleft" style={{ width: "25%", borderLeft: "none", borderRight: "none" }}>Acceptance Criteria</th>
              <th className="PQR_noleft" style={{ width: "35%", borderLeft: "none" }}>Observation  </th>

            </tr>

            {Max_ProcessesTB5()}
            <tr>
              <th className="PQR_noTop">Result</th>
              <td colSpan="7" className="PQR_rt_botm" style={{ textAlign: "left" }}>{pdf[0]?.PQR_MEX_Result}</td>
            </tr>
          </table> </div>
      </>)}

      {/* -------------------------MINIMUM LEAK PATH---------------------------------*/}
      <div
        className="group"
      // style={{textAlign: "right", width: "50%" }}
      >
        <div className="PQRbasemetal" style={{ width: { width } }}>MINIMUM LEAK PATH</div>
      </div>
      <div style={styles.container}>
        <div style={{ paddingTop: "20px" }}></div>
        <table
          id="table"
          className="PQRTable6"
          style={{ width: "45%" }}
        >
          <tbody>
            <tr>
              <th className="left-th PQR_border" rowSpan="2" style={{ width: "15%" }}>
                Tube No
              </th>
              <th className="PQRleft-th-noleft" rowSpan="2" >
                Loc A
              </th>
              <th className="PQRleft-th-noleft" rowSpan="2" >
                Loc B
              </th>
              <th className="PQRleft-th-noleft" rowSpan="2" >
                Loc C
              </th>
              <th className="PQRleft-th-noleft" rowSpan="2" >
                Loc D
              </th>
            </tr>
            <br></br>
            {Min_ProcessesTB1()}
          </tbody>
        </table>

        <table
          id="table"
          className="PQRTable6"
          style={{
            width: "45%",
            position: "relative",
            right: "1.4cm",
          }}
        >
          <tbody>
            <tr>
              <th className="left-th PQR_border" rowSpan="2" style={{ width: "15%" }}>
                Tube No
              </th>
              <th className="PQRleft-th-noleft" rowSpan="2" >
                Loc A
              </th>
              <th className="PQRleft-th-noleft" rowSpan="2" >
                Loc B
              </th>
              <th className="PQRleft-th-noleft" rowSpan="2" >
                Loc C
              </th>
              <th className="PQRleft-th-noleft" rowSpan="2" >
                Loc D
              </th>
            </tr>
            <br></br>
            {Min_ProcessesTB2()}
          </tbody>
        </table>
      </div>

      <br></br>
      <div className="group">
        <table className="PQRTablePg2" style={{ width: { width } }}>
          <tr>
            <th className="PQR_border" style={{ width: "25%" }}>Magnification</th>
            <th className="PQR_noleft" style={{ width: "25%" }}>Acceptance Criteria</th>
            <th className="PQR_noleft" style={{ width: "35%" }}>Observation  </th>

          </tr>

          {Min_ProcessesTB5()}
          <tr>
            <th className="PQR_noTop">Result</th>
            <td colSpan="7" className="PQR_rt_botm" style={{ textAlign: "left" }}>{pdf[0]?.PQR_MLP_Result}</td>
          </tr>
          <tr>
            <th className="PQR_noTop" style={{ width: "35px" }}>Report Number</th>
            <td colSpan="7" className="PQR_rt_botm" style={{ textAlign: "left" }}>{pdf[0]?.PQR_MLP_ReportNumHorizontal}</td>
          </tr>
        </table>  </div>
      {/* ----------------------------footer---------------------------------------------------- */}
      <br></br><br></br>
      <div id="footer" style={{position:"fixed",top:"1965px"}} >
        <PQR_Footer pdf={pdf} previewuser={previewuser} previewapproved={previewapproved}></PQR_Footer>
      </div>
      <br></br><br></br>
      <div id="footer" style={{position:"fixed",top:"2050px"}} >
        <table className="WPSfooter">
          <tr>
            <td>Page 2 of 3</td>
          </tr>
        </table>
      </div>

    </div>
  );
};

export default PQRTubeToTubesheet_pdf_page2;
